import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import logo from '../Assets/logo1.png'

export default function ConfirmGig() {

    let {id} = useParams();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(()=>{
        confirmGig()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const confirmGig = () =>{
        axios.post(`${process.env.REACT_APP_API}/confirm-by-email`, {id})
        .then((res)=>{
            console.log(res.data)
            setError('')
        })
        .catch((e)=>{
            console.log(e)
            const message = e?.response?.data || 'There was a problem confirming this gig. Please contact Niel or an admin.';
            setError(typeof message === 'string' ? message : 'There was a problem confirming this gig. Please contact Niel or an admin.');
        })
        .finally(() => {
            setLoading(false);
        })
    }

  if (loading) {
    return (
      <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', paddingTop:'4rem'}}>
        <img src={logo} alt="Music Gofer" style={{filter:'invert(1)', width:'250px', margin:'2rem'}}/>
        <p>Processing your response...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', paddingTop:'4rem'}}>
        <img src={logo} alt="Music Gofer" style={{filter:'invert(1)', width:'250px', margin:'2rem'}}/>
        <h3>We could not confirm this gig</h3>
        <p style={{padding:'1rem', maxWidth:'480px', textAlign:'center'}}>{error}</p>
      </div>
    );
  }

  return (
    <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', paddingTop:'4rem'}}>
      <img src={logo} alt="Music Gofer" style={{filter:'invert(1)', width:'250px', margin:'2rem'}}/>
      <h3>Thanks for confirming the gig!</h3>
      <p>Please use the Music Gofer app to get all the gig requirements.</p>
    </div>
  )
}
